module.exports = __webpack_public_path__ + "static/media/sportoco-logo.08305a3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportoco-logo.svg
// module id = ./src/assets/images/sportoco-logo.svg
// module chunks = 0